<template>
  <div>
    <b-card
        border-variant="secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        :header="$t('unitChanges.changeHeader')"
        :title= "getTitle"
        align="center"
        class="mx-auto"
        style="max-width: 40rem;"
    >
      <b-card-sub-title class="mb-2">
        <b-icon class="h2" icon="exclamation-triangle-fill" variant="warning"></b-icon>
        <p>{{ getSubTitle}}</p>
      </b-card-sub-title>

      <SecretInputBox @cancelSecretChange="cancelIt" @changeSecret="submitSecretChange"/>
    </b-card>
  </div>
</template>

<script>
import SecretInputBox from "@/components/SecretInputBox";
import router from '@/router/index'
import store from "@/store/store";
import unitApi from "@/services/unitApi";
import userApiService from "@/services/userApiService";

export default {
  name: 'Change Unit Secret',
  props: {
    changeRequested: { type: String }
  },
  components:{SecretInputBox},
  data() {
    return {
      count: 0,
      unit: {
        secret: "",
        guestSecret: ""
      },
      identity: {
        userName: "",
        passphrase: ""
      }
    }
  },
  mounted() {
    this.unit.secret = store.getters.getUnitSecret
    this.unit.guestSecret = store.getters.getUnitGuestSecret
    this.identity.passphrase = store.getters.getSelectedUserPassphrase
    this.identity.userName = store.getters.getSelectedUserName
  },
  computed: {
    getTitle() {
      if (this.changeRequested === "unitSecret") {
        return this.$t('secretChange.unit')
      } else if (this.changeRequested === 'identitySecret'){
        return this.$t('secretChange.identity') + ' ' + this.identity.userName
      }
      return this.$t('secretChange.guest')
    },
    getSubTitle() {
      if (this.changeRequested === "unitSecret") {
        return this.$t('unitSecret.TENANT_ChangeSecretTT')
      } else if(this.changeRequested === 'identitySecret') {
        return this.$t('unitSecret.IDENTITY_ChangeSecretTT')
      }
      return this.$t('unitSecret.GUEST_ChangeSecretTT')
    },
    getLabel(){
      if (this.changeRequested === "unitSecret") {
        return this.$t('unitDetails.unitSecret')
      } else if(this.changeRequested === 'identitySecret') {
        return this.$t('identity.passphrase')
      }
      return this.$t('unitDetails.guestSecret')
    }
  },
  methods: {
  showToast() {
          const h = this.$createElement
          const id = `secretChange-toast-${this.count++}`

          const $closeButton = h(
            'b-button',
            {
              on: { click: () => router.go(-1) }
            },
            'Close'
          )

          this.$bvToast.toast([this.$t('secretChange.successfulSecretUpdate'),$closeButton], {
              id: id,
              title: this.$t('secretChange.secretUpdateTitle'),
              noAutoHide: true,
              toaster: "b-toaster-top-center",
              variant: "success",
              append: false,
              solid: false,
              noCloseButton: true
          })
        },
    cancelIt(){
      router.go(-1)
    },
    async submitSecretChange(secret){
      if(!secret[1]){
        this.$bvToast.toast(this.$t('secretChange.nullSecretMessage'), {
          title: this.$t('secretChange.invalidSecretTitle'),
          autoHideDelay: 5000,
          toaster: "b-toaster-top-center",
          variant:"warning",
          append:false,
          solid: false
        })
      }else{
        if(this.changeRequested === 'identitySecret') {
          this.identity.passphrase =  secret[0]
          await this.updateIdentityPassphrase()
        } else if(this.changeRequested === "unitSecret"){
          await this.updateUnitPassphrase({secret: secret[0]})
        }else{
          await this.updateUnitPassphrase({guestSecret: secret[0]})
        }
      }
    },
    async updateIdentityPassphrase() {
      try {
        await userApiService.updateIdentityPassphrase(store.getters.getSelectedUserId, store.getters.getSelectedUserName, this.identity.passphrase)
        this.showToast()
      }catch(e) {
        if (e.response.status === 400) {
          this.$bvToast.toast(e.response.data.message, {
            title: this.$t('secretChange.errorChangingPassphraseTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        } else {
          this.$bvToast.toast(this.$t('secretChange.errorChangingPassphrase'), {
            title: this.$t('secretChange.errorChangingPassphraseTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        }
      }
    },
    async updateUnitPassphrase(unit) {
      try {
        await unitApi.updateUnit(store.getters.getTenantGuid, unit)
        this.showToast()
      }catch(e) {
        if (e.response.status === 409) {
          this.$bvToast.toast(this.$t('secretChange.invalidSecretMsg'), {
            title: this.$t('secretChange.invalidSecretTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        } else if (e.response.status === 400) {
          this.$bvToast.toast(e.response.data.message, {
            title: this.$t('secretChange.errorChangingPassphraseTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        } else {
          this.$bvToast.toast(this.$t('secretChange.errorChangingPassphrase'), {
            title: this.$t('secretChange.errorChangingPassphraseTitle'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        }
      }
    }
  }

}
</script>
